import { decimalToCents } from '@pesto/utils';

export const calculateUtilizationPercentage = (spent: string, limit: string): number => {
  const limitCents = decimalToCents(limit);

  if (limitCents === 0) return 0;

  return (decimalToCents(spent) * 100) / limitCents;
};
